import { i18nKeys } from '@/src/utils/i18n.utils';
import Avatar from '@amzn/awsui-chat-components/avatar';
import ChatBubble from '@amzn/awsui-chat-components/chat-bubble';
import { Button, SpaceBetween } from '@amzn/awsui-components-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const FacilitatorEscalationConfirmBubble: React.FC<{ onCancel: () => void; onConfirm: () => void | Promise<void> }> =
  memo(({ onCancel, onConfirm }) => {
    const { t } = useTranslation();
    return (
      <ChatBubble
        avatar={
          <Avatar ariaLabel={t(i18nKeys.conversationalAI.ariaLabels.assistant)} color="gen-ai" iconName="gen-ai" />
        }
        type="incoming"
        ariaLabel={t(i18nKeys.conversationalAI.ariaLabels.confirmationRequired)}
      >
        <SpaceBetween direction="vertical" size="s">
          <span>{t(i18nKeys.conversationalAI.escalation.prompt)}</span>
          <SpaceBetween direction="horizontal" size="s">
            <Button variant="primary" onClick={onConfirm}>
              {t(i18nKeys.conversationalAI.escalation.confirm)}
            </Button>
            <Button onClick={onCancel}>{t(i18nKeys.conversationalAI.escalation.cancel)}</Button>
          </SpaceBetween>
        </SpaceBetween>
      </ChatBubble>
    );
  });

export default FacilitatorEscalationConfirmBubble;
